import dashboard from "./Dashboard.png";
import logo from "./snookerlogo.png";
import unclickDashboard from "./DashboardDefault.png";
import notificationbell from "./notificationbell.png";
import headerimg from "./headerimg.png";
import booking from "./BookingDefault.png";
import customer from "./CustomerDefault.png";
import tables from "./TableDefault.png";
import dues from "./DuesDefault.png";
import staff from "./SettingDefault.png";
import expense from "./ExpenseDefault.png";
import report from "./ReportDefault.png";
import setting from "./SettingDefault.png";
import logout from "./LogOutDefault.png";
import activebooking from "./activeBooking.png";
import activecustomer from "./activeCustomer.png";
import activetables from "./activetable.png";
import activeexpense from "./activeExpense.png";
import activereport from "./activeReport.png";
import activesetting from "./activeSetting.png";
import loginimage from "./loginimage.png";
import loginclipimage from "./Clip path group.png";
import snookercardimg from "./Group 604.png";
import cash from "./cash.png";
import card from "./card.png";
import upi from "./upi.png";
import prime from "./prime.png";
import percent from "./percent.png";
import wallet from "./wallet.png";
import transactionpath1 from "./Path 2 Copy.png";
import transactionpath2 from "./Path 4.png";
import snookercardarrow from "./snookercardarrow.png";
import refreshicon from "./refreshicon.png";
import birthday from "./birthday.png";
import workanniversary from "./work.png";
import users from "./user.png";
import sidebarline from "./sidebarline.png";
import cutomerimage from "./cutomerimg2.png";
import rupee from "./rupee.png";
import membership from "./membership.png";
import winner from "./winner.png";
import rewardpoints from "./rewardpoints.png";
import games from "./games.png";
import chechin from "./check in.png";
import nodataimg from "./nodataimage.png";
import netamount from "./netamount.png";
import discount from "./discount.png";
import duesreport from "./repoerdues.png";
import cashreport from "./reportcash.png";
import cardreport from "./cardreport.png";
import reportupi from "./upireport.png";
import gemes from "./gemes.png";
import settingbackground from "./Accountbackground.png";
import dashboardsetttingicon from "./dashboardsetting.png";
import rectangle17 from "./Rectangle 17.png";
import rectangle18 from "./Rectangle 18.png";
import rectangle19 from "./Rectangle 19.png";
import customerperson from "./customerperson.png";
import roleicon from "./RolesDefault.png";
import activeroleicon from "./activeroleicon.png";
import categoryicon from "./CategoryDefault.png";
import activecategoryicon from "./activecategoryicon.png";
import subscriptionimg from "./subscriptionimg.png";
import Active from "./Active.png";
import Deactive from "./deactive.png";
import defaultprofilepicture from "./defaultprofilepic.png";
import paymentWhite from "./Pay history white.png";
import paymentGreen from "./Pay history green.png";
import dueWhite from "./Dues white.png";
import settingprof from "./cutomerimg2.png";
// canteen images
import pasta from "./pasta.png";
import seasonedfood from "./spicyseasoned.png";
import downloadimage from "./download icon.png";
import ontogleswitch from "./onToggle switch.png";
import offtogleswitch from "./offToggle switch.png";
import canteenloginimage from "./canteenLoginImage.png";
import activeOrder from "./activeOrder.png";
import defaultOrder from "./defaultOrder.png";
import activeItem from "./activeItem.png";
import defaultItem from "./defaultItem.png";
import activeStock from "./activeStock.png";
import defaultStock from "./defaultStock.png";
import foodbgimage from "./foodbgimage.png";
import gamezoneimage from "./pngtree-gaming-zone-neon-sign-image_16146164.jpg";
import scanner from "./Scanner.png";
import eggdish from "./eggdish.png";
import seafoodpasta from "./sefoodpastas.png";
import noddles from "./noodles.png";
import seadfood from "./seafoood.png";
import cocoCola from "./coco cola.avif";
import emptyCart from "./empty cart image.png";
import BGimage from "./BGimage.png"
import platesimages from "./Plate images.png";
import Paytm from "./paytm (2).png";
import phonepay from "./phonepay.png";
import Gpay from "./googlepay.png";
import bhim from "./bhim (2).png";
import orderdeatilslogo from "./orderdetaillogo.png";
import noorderimage from "./NoOrderFOund image.png";
import noorderimagedash from "./noOrderdashboard image.png";

const images = {
  subscriptionimg,
  settingprof, roleicon,
  activeroleicon,
  categoryicon,
  activecategoryicon,
  customerperson,
  rectangle17,
  rectangle18,
  rectangle19,
  dashboardsetttingicon,
  dashboard,
  logo,
  unclickDashboard,
  notificationbell,
  headerimg,
  booking,
  customer,
  tables,
  dues,
  staff,
  expense,
  report,
  setting,
  logout,
  activebooking,
  activecustomer,
  activetables,
  activeexpense,
  activereport,
  activesetting,
  loginimage,
  loginclipimage,
  snookercardimg,
  cash,
  card,
  upi,
  prime,
  percent,
  wallet,
  transactionpath1,
  transactionpath2,
  snookercardarrow,
  refreshicon,
  birthday,
  workanniversary,
  users,
  sidebarline,
  cutomerimage,
  rupee,
  membership,
  winner,
  rewardpoints,
  games,
  chechin,
  nodataimg,
  netamount,
  discount,
  duesreport,
  cashreport,
  cardreport,
  reportupi,
  gemes,
  settingbackground,
  Active,
  Deactive,
  defaultprofilepicture,
  paymentWhite,
  paymentGreen,
  dueWhite,
  // canteen flow
  pasta,
  seasonedfood,
  downloadimage,
  ontogleswitch,
  offtogleswitch,
  canteenloginimage,
  activeOrder,
  defaultOrder,
  activeItem,
  defaultItem,
  activeStock,
  defaultStock,
  // canteenuser
  foodbgimage,
  gamezoneimage,
  scanner,
  eggdish,
  seafoodpasta,
  noddles,
  seadfood,
  cocoCola,
  emptyCart,
  BGimage,
  platesimages,
  Paytm,
  phonepay,
  Gpay,
  bhim,orderdeatilslogo,noorderimage,noorderimagedash
};

export default images;
